import { useState } from "react";
import { KeyRound, LogOut } from "lucide-react";
import { useAuth } from "@/stores/auth-store";
import { useLogout } from "@/api/auth";
import { ChangePasswordDialog } from "@/components/change-password-dialog";
import { cn } from "@/lib/utils";

const roleBadgeColors: Record<string, string> = {
  super_admin: "bg-danger/10 text-danger",
  operator: "bg-accent/10 text-accent",
  client_admin: "bg-warning/10 text-warning",
  client_viewer: "bg-info/10 text-info",
};

export function TopBar() {
  const { user } = useAuth();
  const logout = useLogout();
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);

  const handleLogout = () => {
    logout.mutate();
  };

  return (
    <>
      <header className="flex h-14 items-center justify-between border-b border-border bg-surface/80 px-6">
        <div />
        <div className="flex items-center gap-4">
          {user && (
            <>
              <span
                className={cn(
                  "rounded-full px-2.5 py-0.5 text-xs font-medium",
                  roleBadgeColors[user.role] || "bg-surface-hover text-text-secondary"
                )}
              >
                {user.role.replace("_", " ")}
              </span>
              <span className="text-sm text-text-secondary">{user.email}</span>
            </>
          )}
          <button
            onClick={() => setChangePasswordOpen(true)}
            className="rounded p-1.5 text-text-muted hover:bg-surface-hover hover:text-text-primary"
            title="Change Password"
          >
            <KeyRound className="h-4 w-4" />
          </button>
          <button
            onClick={handleLogout}
            className="rounded p-1.5 text-text-muted hover:bg-surface-hover hover:text-text-primary"
            title="Logout"
          >
            <LogOut className="h-4 w-4" />
          </button>
        </div>
      </header>
      <ChangePasswordDialog open={changePasswordOpen} onClose={() => setChangePasswordOpen(false)} />
    </>
  );
}
